<template>
  <div id="order-manage" class="scroll-container">

    <!-- 搜索 -->
    <div class="top-container" v-show="showTopContainer">
      <div class="top">
        <span>学段：</span>
        <el-radio-group v-model="xd" @change="search" size="small">
          <el-radio-button v-for="option in xdOptions" :key="option" :label="option">{{ option }}</el-radio-button>
        </el-radio-group>
      </div>

      <div class="top">
        <span>年级：</span>
        <el-radio-group v-model="grade" @change="search" size="small">
          <el-radio-button v-for="option in gradeOptions" :key="option" :label="option">{{ option }}</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 学科选择框 -->
      <div class="top">
        <span>学科：</span>
        <el-radio-group v-model="subject" @change="search" size="small">
          <el-radio-button v-for="option in subjectOptions" :key="option" :label="option">{{ option }}</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 版本选择框 -->
      <div class="top">
        <span>版本：</span>
        <el-radio-group v-model="version" @change="search" size="small">
          <el-radio-button v-for="option in versionOptions" :key="option" :label="option">{{ option }}</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 册次选择框 -->
      <div class="top">
        <span>册次：</span>
        <el-radio-group v-model="volume" @change="search" size="small">
          <el-radio-button v-for="option in volumeOptions" :key="option" :label="option">{{ option }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <!-- 按钮 -->
    <div class="show">
      <el-button v-if="showTopContainer" @click="toggleTopContainer">隐藏筛选</el-button>
      <el-button v-else @click="toggleTopContainer">显示筛选</el-button>
    </div>

    <!-- 左边折叠展开 -->
    <div class="container">
      <!-- 左边折叠展开 -->
      <div class="tree-container">
        <div class="zjt">
          <span>章节选择：</span>
          <el-tree :data="tableData" :props="defaultProps" accordion @node-click="handleNodeClick"></el-tree>
        </div>
      </div>

      <!-- 表格 -->
      <div class="card-container">
        <div class="card-list">
    <el-collapse-card shadow="always" v-for="card in cardList" :key="card.video_id" class="card-item" :body-style="{ padding: '0px' }" @click="openPlayerDialog(card.video_id)">
      <img src="http://120.26.124.66/mg.jpg" class="image" style="height: 38%;width: 100%;">
      <div style="padding: 14px;">
        <span class="video-name">{{ card.video }}</span>
        <div class="bottom clearfix">

        </div>
        <time class="time">{{ '视频时长: ' + card.times }}</time>

      </div>
    </el-collapse-card>
  </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination @current-change="currentChange" background layout="prev, pager, next" :page-size="8" :page-count="total"></el-pagination>
    </div>

    <!-- 加载中的弹窗 -->
    <div v-if="showLoadingModal" class="loading-modal">
      <div class="loading-text">视频加载中...</div>
    </div>

    <!--在线播放-->
    <div class='video'>
      <el-dialog title="视频播放" :visible.sync="playerDialogVisible" width="800px" @close="closePlayerDialog" append-to-body >
          <video ref="videoPlayer" :src="videoNewUrl" controls width="100%" autoplay  controlsList="nodownload" preload="none">

          </video>
        </el-dialog>
    </div>

    </div>
</template>

<script>
    import {getCurrentPageBOrder,getCardPageBOrder,getVideoUrl} from '../../../api/index'
    import {MessageBox,Message, version} from 'element-ui'
    import md5 from 'md5';

    export default {
        name: "OrderManage",
        data(){
          return{
            tableData:[],
            xdOptions:[],
            gradeOptions:[],
            subjectOptions:[],
            versionOptions:[],
            volumeOptions:[],
            total:0,
            defaultProps: {
          children: 'children',
          label: 'label'
        },
            currentPage:1,
            dialogFormVisible:false,
            dialogTitle:'',
            labelPosition:'left',
            input:'',
            xd:'小学',
            grade:'一年级',
            subject:'语文',
            version:'部编版',
            volume:'上册',
            searchInput:'',
            videoUrl:'',
            videoNewUrl:'',
            cardList : [],
            selectedNodes : [],
            adminInfo: {
      uid: ''
    },
            playerDialogVisible: false,
            showTopContainer: true,
            gradeOptions_dict: [
                    { name: '小学', value: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级'] },
                    { name: '初中', value: ['七年级', '八年级', '九年级'] },
                    { name: '高中', value: ['高一', '高二', '高三'] }],
            subjectOptions_dict:[
            { name: '一年级', value: ['语文', '数学'] },
            { name: '二年级', value: ['语文', '数学'] },
            { name: '三年级', value: ['语文', '数学','英语'] },
            { name: '四年级', value: ['语文', '数学','英语'] },
            { name: '五年级', value: ['语文', '数学','英语'] },
            { name: '六年级', value: ['语文', '数学','英语','科学'] },
            { name: '七年级', value: ['语文', '数学','英语','生物','地理','历史','道德与法治'] },
            { name: '八年级', value: ['语文', '数学','英语','物理','生物','地理','历史','道德与法治'] },
            { name: '九年级', value: ['语文', '数学','英语','物理','化学','历史','道德与法治'] },
            { name: '高一', value: ['语文', '数学','英语','物理','生物','化学'] },
            { name: '高二', value: ['语文', '数学','英语','物理','生物','化学'] },
            { name: '高三', value: ['语文', '数学','物理','生物','化学'] },
            ],
            versionOptions_dict:[
            {"name":"语文",'xd':'小学','nj':'一年级','value': ['部编版']},
            {"name":"语文",'xd':'小学','nj':'二年级','value': ['部编版']},
            {"name":"语文",'xd':'小学','nj':'三年级','value': ['部编版']},
            {"name":"语文",'xd':'小学','nj':'四年级','value': ['部编版']},
            {"name":"语文",'xd':'小学','nj':'五年级','value': ['部编版']},
            {"name":"语文",'xd':'小学','nj':'六年级','value': ['部编版']},
            {"name":"语文",'xd':'初中','nj':'七年级','value': ['部编版']},
            {"name":"语文",'xd':'初中','nj':'八年级','value': ['部编版']},
            {"name":"语文",'xd':'初中','nj':'九年级','value': ['部编版']},
            {"name":"语文",'xd':'高中','nj':'高一','value': ['部编版']},
            {"name":"语文",'xd':'高中','nj':'高二','value': ['部编版']},
            {"name":"语文",'xd':'高中','nj':'高三','value': ['部编版']},

            {"name":"数学",'xd':'小学','nj':'一年级','value': ['人教版']},
            {"name":"数学",'xd':'小学','nj':'二年级','value': ['人教版']},
            {"name":"数学",'xd':'小学','nj':'三年级','value': ['人教版']},
            {"name":"数学",'xd':'小学','nj':'四年级','value': ['人教版']},
            {"name":"数学",'xd':'小学','nj':'五年级','value': ['人教版']},
            {"name":"数学",'xd':'小学','nj':'六年级','value': ['人教版']},
            {"name":"数学",'xd':'初中','nj':'七年级','value': ['人教版']},
            {"name":"数学",'xd':'初中','nj':'八年级','value': ['人教版']},
            {"name":"数学",'xd':'初中','nj':'九年级','value': ['人教版']},
            {"name":"数学",'xd':'高中','nj':'高一','value': ['人教版','人教版新课标A版']},
            {"name":"数学",'xd':'高中','nj':'高二','value': ['人教版','人教版新课标A版']},
            {"name":"数学",'xd':'高中','nj':'高三','value': ['人教版','人教版新课标A版']},

            {"name":"英语",'xd':'小学','nj':'三年级','value': ['人教版(PEP)三年级起']},
            {"name":"英语",'xd':'小学','nj':'四年级','value': ['人教版(PEP)三年级起']},
            {"name":"英语",'xd':'小学','nj':'五年级','value': ['通用版','人教版(PEP)三年级起']},
            {"name":"英语",'xd':'小学','nj':'六年级','value': ['通用版','人教版(PEP)三年级起']},
            {"name":"英语",'xd':'初中','nj':'七年级','value': ['仁爱版','人教版']},
            {"name":"英语",'xd':'初中','nj':'八年级','value': ['仁爱版','人教版']},
            {"name":"英语",'xd':'初中','nj':'九年级','value': ['仁爱版','人教版']},
            {"name":"英语",'xd':'高中','nj':'高一','value': ['人教版']},
            {"name":"英语",'xd':'高中','nj':'高二','value': ['人教版']},
            {"name":"英语",'xd':'高中','nj':'高三','value': ['人教版']},


            {"name":"物理",'xd':'初中','nj':'八年级','value': ['人教版','北师大版']},
            {"name":"物理",'xd':'初中','nj':'九年级','value': ['人教版','北师大版']},
            {"name":"物理",'xd':'高中','nj':'高一','value': ['人教版']},
            {"name":"物理",'xd':'高中','nj':'高二','value': ['人教版']},


            {"name":"生物",'xd':'初中','nj':'七年级','value': ['人教版']},
            {"name":"生物",'xd':'初中','nj':'八年级','value': ['人教版']},
            {"name":"生物",'xd':'高中','nj':'高一','value': ['人教版']},
            {"name":"生物",'xd':'高中','nj':'高二','value': ['人教版']},
            {"name":"生物",'xd':'高中','nj':'高三','value': ['人教版']},

            {"name":"化学",'xd':'初中','nj':'九年级','value': ['人教版']},
            {"name":"化学",'xd':'高中','nj':'高一','value': ['人教版']},
            {"name":"化学",'xd':'高中','nj':'高二','value': ['人教版']},
            {"name":"化学",'xd':'高中','nj':'高三','value': ['人教版']},

            {"name":"地理",'xd':'初中','nj':'七年级','value': ['人教版']},
            {"name":"地理",'xd':'初中','nj':'八年级','value': ['人教版']},

            {"name":"历史",'xd':'初中','nj':'七年级','value': ['部编版']},
            {"name":"历史",'xd':'初中','nj':'八年级','value': ['部编版']},
            {"name":"历史",'xd':'初中','nj':'九年级','value': ['部编版']},

            {"name":"科学",'xd':'小学','nj':'六年级','value': ['通用版']},

            {"name":"道德与法治",'xd':'初中','nj':'七年级','value': ['部编版']},
            {"name":"道德与法治",'xd':'初中','nj':'八年级','value': ['部编版']},
            {"name":"道德与法治",'xd':'初中','nj':'九年级','value': ['部编版']},

            ],
            volumeOptions_dict:[

            {"name":"语文","xd":'小学','bb':"部编版",'nj':"一年级",'value': ['上册', '下册']},
            {"name":"语文","xd":'小学','bb':"部编版",'nj':"二年级",'value': ['上册', '下册']},
            {"name":"语文","xd":'小学','bb':"部编版",'nj':"三年级",'value': ['上册', '下册']},
            {"name":"语文","xd":'小学','bb':"部编版",'nj':"四年级",'value': ['上册', '下册']},
            {"name":"语文","xd":'小学','bb':"部编版",'nj':"五年级",'value': ['上册', '下册']},
            {"name":"语文","xd":'小学','bb':"部编版",'nj':"六年级",'value': ['上册', '下册','总复习','课外拓展']},

            {"name":"语文","xd":'初中','bb':"部编版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"语文","xd":'初中','bb':"部编版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"语文","xd":'初中','bb':"部编版",'nj':"九年级",'value': ['上册', '下册','总复习','课外拓展']},

            {"name":"语文","xd":'高中','bb':"部编版",'nj':"高一",'value': ['必修上', '必修下']},
            {"name":"语文","xd":'高中','bb':"部编版",'nj':"高二",'value': ['选择性必修上','选择性必修中']},
            {"name":"语文","xd":'高中','bb':"部编版",'nj':"高三",'value': ['选择性必修下']},

            {"name":"数学","xd":'小学','bb':"人教版",'nj':"一年级",'value': ['上册', '下册']},
            {"name":"数学","xd":'小学','bb':"人教版",'nj':"二年级",'value': ['上册', '下册']},
            {"name":"数学","xd":'小学','bb':"人教版",'nj':"三年级",'value': ['上册', '下册']},
            {"name":"数学","xd":'小学','bb':"人教版",'nj':"四年级",'value': ['上册', '下册']},
            {"name":"数学","xd":'小学','bb':"人教版",'nj':"五年级",'value': ['上册', '下册']},
            {"name":"数学","xd":'小学','bb':"人教版",'nj':"六年级",'value': ['上册', '下册','总复习']},

            {"name":"数学","xd":'初中','bb':"人教版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"数学","xd":'初中','bb':"人教版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"数学","xd":'初中','bb':"人教版",'nj':"九年级",'value': ['上册', '下册','总复习']},

            {"name":"数学","xd":'高中','bb':"人教版",'nj':"高一",'value': ['必修一', '必修二','必修三']},
            {"name":"数学","xd":'高中','bb':"人教版",'nj':"高二",'value': ['必修四','必修五','选择性必修一']},
            {"name":"数学","xd":'高中','bb':"人教版",'nj':"高三",'value': ['选择性必修二','选择性必修三','总复习']},

            {"name":"数学","xd":'高中','bb':"人教版新课标A版",'nj':"高一",'value': ['必修一', '必修二']},
            {"name":"数学","xd":'高中','bb':"人教版新课标A版",'nj':"高二",'value': ['选择性必修一','选择性必修二']},
            {"name":"数学","xd":'高中','bb':"人教版新课标A版",'nj':"高三",'value': ['选择性必修三','总复习']},

            {"name":"英语","xd":'小学','bb':"人教版(PEP)三年级起",'nj':"三年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'小学','bb':"人教版(PEP)三年级起",'nj':"四年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'小学','bb':"人教版(PEP)三年级起",'nj':"五年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'小学','bb':"人教版(PEP)三年级起",'nj':"六年级",'value': ['上册', '下册']},

            {"name":"英语","xd":'小学','bb':"通用版",'nj':"五年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'小学','bb':"通用版",'nj':"六年级",'value': ['上册', '下册']},

            {"name":"英语","xd":'初中','bb':"仁爱版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'初中','bb':"仁爱版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'初中','bb':"仁爱版",'nj':"九年级",'value': ['上册', '下册','总复习']},

            {"name":"英语","xd":'初中','bb':"人教版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'初中','bb':"人教版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"英语","xd":'初中','bb':"人教版",'nj':"九年级",'value': ['总复习', '全一册']},

            {"name":"英语","xd":'高中','bb':"人教版",'nj':"高一",'value': ['必修一', '必修二','必修三']},
            {"name":"英语","xd":'高中','bb':"人教版",'nj':"高二",'value': ['选择性必修一','选择性必修二']},

            {"name":"物理","xd":'初中','bb':"人教版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"物理","xd":'初中','bb':"人教版",'nj':"九年级",'value': ['全一册','总复习']},

            {"name":"物理","xd":'初中','bb':"北师大版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"物理","xd":'初中','bb':"北师大版",'nj':"九年级",'value': ['全一册','总复习']},

            {"name":"物理","xd":'高中','bb':"人教版",'nj':"高一",'value': ['必修一', '必修二','必修三']},
            {"name":"物理","xd":'高中','bb':"人教版",'nj':"高二",'value': ['选择性必修一', '选择性必修二']},
            {"name":"物理","xd":'高中','bb':"人教版",'nj':"高三",'value': ['选择性必修三', '总复习']},

            {"name":"生物","xd":'初中','bb':"人教版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"生物","xd":'初中','bb':"人教版",'nj':"八年级",'value': ['上册', '下册','总复习']},

            {"name":"生物","xd":'高中','bb':"人教版",'nj':"高一",'value': ['必修一', '必修二']},
            {"name":"生物","xd":'高中','bb':"人教版",'nj':"高二",'value': ['选择性必修一','选择性必修二']},
            {"name":"生物","xd":'高中','bb':"人教版",'nj':"高三",'value': ['选择性必修三','总复习']},

            {"name":"化学","xd":'初中','bb':"人教版",'nj':"九年级",'value': ['上册', '下册','总复习']},

            {"name":"化学","xd":'高中','bb':"人教版",'nj':"高一",'value': ['必修一', '必修二']},
            {"name":"化学","xd":'高中','bb':"人教版",'nj':"高二",'value': ['选择性必修一','选择性必修二']},
            {"name":"化学","xd":'高中','bb':"人教版",'nj':"高三",'value': ['选择性必修三','总复习']},




            {"name":"地理","xd":'初中','bb':"人教版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"地理","xd":'初中','bb':"人教版",'nj':"八年级",'value': ['上册', '下册','总复习']},

            {"name":"历史","xd":'初中','bb':"部编版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"历史","xd":'初中','bb':"部编版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"历史","xd":'初中','bb':"部编版",'nj':"九年级",'value': ['上册', '下册']},

            {"name":"科学","xd":'小学','bb':"通用版",'nj':"六年级",'value': ['自然','地球','实验']},

            {"name":"道德与法治","xd":'初中','bb':"部编版",'nj':"七年级",'value': ['上册', '下册']},
            {"name":"道德与法治","xd":'初中','bb':"部编版",'nj':"八年级",'value': ['上册', '下册']},
            {"name":"道德与法治","xd":'初中','bb':"部编版",'nj':"九年级",'value': ['上册', '下册']},


            ],
            z: '', // 第一级名称
            j: '', // 第二级名称
            t: '', // 第三级名称
            showLoadingModal: false
          }
        },
        created() {
        this.xdOptions = ['小学', '初中', '高中'];
        this.gradeOptions = ['一年级','二年级','三年级','四年级','五年级','六年级'];
        this.subjectOptions = ['语文','数学']
        this.versionOptions = ['部编版']
        this.volumeOptions = ['上册','下册']
        this.loadCurrentPageOrder(this.currentPage,8,'','小学','一年级','语文','部编版','上册');
        this.tableData = [
    {
      "children": [
        {
          "children": [],
          "label": "拼音"
        }
      ],
      "label": "拼音"
    },
    {
      "children": [
        {
          "children": [],
          "label": "第一单元"
        }
      ],
      "label": "第一单元"
    }
  ];
        loadAdminInfo();
        loadGetCardPageBOrder(1,8,'拼音','拼音','','');

        },
        methods:{

        async openPlayerDialog(vid) {
        this.showLoadingModal = true;
        this.uid = this.$cookies.get("uid")
          let json = await getVideoUrl(vid, this.uid );
                if (json.code === '200') {
                  Message.success('欢迎使用 芒果100分')

                  this.videoUrl = json.data.video_url.replace("https://", "http://");
                  console.log(this.videUrl)
                  const timess = String(Math.floor(Date.now() / 1000)); // 当前整型时间戳转换为字符串类型
                  const sign = md5(String(vid) + timess + 'thisismg');
                  const params = new URLSearchParams();
                  params.append('video', vid);
                  params.append('times', timess);
                  params.append('sign', sign);

                  this.videoNewUrl = `${this.videoUrl}?${params.toString()}`;
                  console.log(this.videoNewUrl)
                  this.playerDialogVisible = true;
                }  else {
                Message.error(json.msg)
                }

        },
        async closePlayerDialog() {
          this.playerDialogVisible = false;
          this.showLoadingModal = false;
          // 在关闭播放窗口时，可以停止视频的播放
          this.$refs.videoPlayer.pause();
        },

        async loadAdminInfo() {
        console.log(this.$cookies );
            if (this.$cookies.get("name")) {

                this.adminInfo.name = this.$cookies.get("name");
                this.adminInfo.uid = this.$cookies.get("uid");
                this.adminInfo.avatar = this.$cookies.get("avatar");
              console.log(this.adminInfo )
            } else {

              Message.error("未登陆，暂无权限查看！");
            }
          },

        toggleTopContainer() {
            this.showTopContainer = !this.showTopContainer; // 切换 showTopContainer 的值
          },

        handleNodeClick(tableData) {
        this.currentPage = 1;
          console.log(tableData.levle)
            if (tableData.levle === 1) {
              this.z = tableData.label
              };
            if (tableData.levle === 2) {
              this.j = tableData.label
              this.t = '';
              this.loadGetCardPageBOrder(this.currentPage, 8, this.z, this.j, this.t,this.grade);

              };
            if (tableData.levle === 3) {
              this.t = tableData.label;
              };
            if (!tableData.children || tableData.children.length === 0) {
              this.loadGetCardPageBOrder(this.currentPage, 8, this.z, this.j, this.t,this.grade);
          }
        },



        async loadGetCardPageBOrder(currentPage, pageSize, z, j, t,grade) {

                let json = await getCardPageBOrder(currentPage, pageSize, z, j, t,grade);
                if (json.code === '200') {
                Message.success('欢迎使用 芒果100分')
                  this.cardList = json.data;
                  this.total = Math.ceil(json.total / 9);
                }  else {
                this.cardList = [];
                Message.error('该版本资源正在组织制作')
                }
              },

        async loadCurrentPageOrder(currentPage, pageSize, input, xd, grade, subject, version,volume) {

                let json = await getCurrentPageBOrder(currentPage, pageSize,input, xd, grade, subject, version,volume);
                if (json.code === '200') {
                  this.tableData = json.data;
                  this.total = Math.ceil(json.total / 8);
                }  else {
                this.tableData = [];
                Message.error('该版本资源正在组织制作')
                }
              },
          async currentChange(currentPage){
            this.currentPage = currentPage;
            this.loadGetCardPageBOrder(this.currentPage,8,this.z,this.j,this.t,this.grade);
          },
          //搜索订单
          search(){

              this.setGradeOptions();
              console.log(1,this.xd,this.grade)
              this.setsubjectOptions();
              console.log(11,this.xd,this.grade,this.subject)
              this.setversionOptions();
              console.log(111,this.xd,this.grade,this.subject,this.version)
              this.setvolumeOptions();
              console.log(1111,this.xd,this.grade,this.subject,this.version,this.volume)
              this.loadCurrentPageOrder(this.currentPage,8,'',this.xd,this.grade,this.subject,this.version,this.volume);
              this.cardList = [];

            },
          setGradeOptions() {
              const gradeOptionsObj = this.gradeOptions_dict.find(option => option.name === this.xd);
              if (gradeOptionsObj) {
                this.gradeOptions = gradeOptionsObj.value;
                if (!this.gradeOptions.includes(this.grade)) {
                  this.grade = gradeOptionsObj.value[0];
                }
              } else {
                this.gradeOptions = [];
                this.grade = '';
              }
            },
          setsubjectOptions() {
              const subjectOptionsObj = this.subjectOptions_dict.find(option => option.name === this.grade);
              if (subjectOptionsObj) {
                this.subjectOptions = subjectOptionsObj.value;
                if (!this.subjectOptions.includes(this.subject)) {
                  this.subject = subjectOptionsObj.value[0];
                }
              } else {
                this.subjectOptions = [];
                this.subject = '';
              }
            },
          setversionOptions() {
              const versionOptionsObj = this.versionOptions_dict.find(option => option.name === this.subject && option.xd === this.xd && option.nj === this.grade);
              if (versionOptionsObj) {
                this.versionOptions = versionOptionsObj.value;
                if (!this.versionOptions.includes(this.version)) {
                  this.version = versionOptionsObj.value[0];
                }
              } else {
                this.versionOptions = [];
                this.version = '';
              }
            },
          setvolumeOptions() {
          console.log('setvolumeOptions',this.subject,this.xd,this.version,this.grade)
              const volumeOptionsObj = this.volumeOptions_dict.find(option => option.name === this.subject && option.xd === this.xd && option.bb === this.version &&
              option.nj === this.grade);
              if (volumeOptionsObj) {
                this.volumeOptions = volumeOptionsObj.value;
                if (!this.volumeOptions.includes(this.volume)) {
                  this.volume = volumeOptionsObj.value[0];
                }
              } else {
                this.volumeOptions = [];
                this.volume = '';
              }
            },
          handleDelete(index, row) {
            MessageBox.confirm('此操作将永久删除该订单所有信息, 是否继续？','提示').then(async (value)=>{
              if (value==='confirm'){
                let json = await deleteOrder(row.id);
                if (json.state===200){
                  Message.success('删除该订单成功！');
                  this.loadCurrentPageOrder(this.currentPage,8,this.searchInput);
                }
              }
            });
            console.log(index, row);
          },
        }
    }
</script>

<style>
.scroll-container {
  height: 500px;
  overflow-y: auto;
}

.top-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  margin: 0 auto;
  max-width: 900px;
}

.top {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.top span {
  margin-right: 10px;
  align-self: flex-start;
  font-size: 14px;
}

.el-radio-button {
  font-size: 12px;
}

.show {
  text-align: center;
}

.container {
  display: flex;
  justify-content: space-between;
}

.tree-container {
  flex: 1;
  width: 25%;
  margin-right: 20px;
}

.card-container {
  flex: 3;
  width: 75%;
  margin-left: 20px;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.card-item {
  width: calc(25% - 15px);
  margin: 10px;
}

.image {
  width: 120%;
  height: 180px;
  object-fit: cover;
}

.bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.time {
  font-size: 12px;
}

.button {
  font-size: 12px;
}
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.loading-text {
  font-size: 16px;
  color: #fff;
}

</style>




// WEBPACK FOOTER //
// src/pages/business/children/OrderManage.vue